import ServicesSection from "../components/home/servicesSection";
import WebshopPromo from "../components/home/WebshopPromo";
import ArticlesSection from "../components/home/ArticlesSection";
import FeaturedProjects from "../components/home/FeaturedProjects";
import CareersSection from "../components/home/CareersSection";
import { DesignHero } from "../components/home/DesignHero";
import { JobsNotice } from "../components/home/JobsNotice";
import { ClimateStrip } from "../components/home/ClimateStrip";
import { ProcessSteps } from "../components/home/ProcessSteps";
import { ContactCTA } from "../components/home/ContactCTA";
import { isChristmasPeriod } from "../components/utils/ChristmasUtils";

/**
 * Airon home page — clean, single-flow design:
 *   Hero → JobsNotice → Tjenester → Inneklima (ClimateStrip) → Prosess
 *   → Prosjekter → Karriere → Nettbutikk → Artikler → Kontakt-CTA
 *
 * The old slick-carousel "Aktuelt" slider and the two PMCards
 * (Service/Support + Serviceavtale) have been replaced by the
 * integrated flow above. A light Christmas banner still shows during
 * the holiday window without taking over the page.
 */
export const Home = () => {
  return (
    <>
      <DesignHero />

      <JobsNotice />

      {isChristmasPeriod() && (
        <section className="sec" style={{ borderTop: "none", padding: "40px 0" }}>
          <div className="wrap">
            <div
              style={{
                background: "linear-gradient(135deg, #DC2626 0%, #7F1D1D 100%)",
                color: "#fff",
                borderRadius: 20,
                padding: "28px 32px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 20,
                flexWrap: "wrap",
              }}
            >
              <div>
                <div
                  style={{
                    fontFamily: "var(--mono)",
                    fontSize: 11,
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    opacity: 0.8,
                  }}
                >
                  God jul
                </div>
                <div
                  style={{
                    fontFamily: "var(--display)",
                    fontSize: 24,
                    marginTop: 4,
                  }}
                >
                  God jul og godt nytt år fra alle oss i Airon.
                </div>
              </div>
              <span style={{ fontSize: 40 }}>🎄</span>
            </div>
          </div>
        </section>
      )}

      <ServicesSection />

      <section className="sec" style={{ borderTop: "none" }}>
        <div className="wrap">
          <ClimateStrip />
        </div>
      </section>

      <ProcessSteps />

      <FeaturedProjects />

      <CareersSection />

      <WebshopPromo />

      <ArticlesSection />

      <ContactCTA />
    </>
  );
};
